import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/* 
This variable will change the layout of the website from multipage to single, scrollable page
*/
export let singlePage = false;

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Ibrohim",
    lastName: "Ruzmetov",
    initials: "ML", // the example uses first and last, but feel free to use three or more if you like.
    position: "Full Stack Developer & Data Scientist", // this is the title that will be displayed on the homepage
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: '💻',
            text: 'BSc Data Science and AI, MBA E-commerce and Company Management'
        },
        {
            emoji: '🌎',
            text: 'based in the Tashkent, Uzbekistan'
        },
        {
            emoji: "💼",
            text: "Full stack developer & AI & Data Scientist"
        },
        {
            emoji: "📧",
            text: "ibruzmetov@yandex.com"
        }
    ],
    socials: [
        {
            link: "https://instagram.com/Ibrokhim_rm",
            icon: 'fa fa-instagram',
            label: 'instagram'
        },
        {
            link: "https://github.com/Rub4ik",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://linkedin.com/in/aimlfsd/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        },
        {
            link: "https://t.me/Thatweix",
            icon: "fa fa-telegram",
            label: 'telegram'
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Greetings! I'm Ibrohim Ruzmetov. I'm a Full stack developers & AI & Data Scientist. I've studied BSc, MBA at WSEI, Poland. I love the logic and structure of coding and always strive. You should hire me!",
    skills:
        {
            proficientWith: ['JavaScript', 'React', 'Git', 'Github', 'Bootstrap', 'HTML5', 'CSS3', 'scikit-learn', 'Tensorflow', 'Pandas', 'NumPy', 'Flask', 'XGboost'],
            exposedTo: ['NodeJS', 'Python', 'Adobe photoshop']
        }
    ,
    hobbies: [
        {
            label: 'Coding',
            emoji: '📖'
        },
        {
            label: 'Chess',
            emoji: '♟'
        },
        {
            label: 'GYM',
            emoji: '🏋'
        },
        {
            label: 'Cooking',
            emoji: '🌶'
        }
// Same as above, change the emojis to match / relate to your hobbies or interests.
// You can also remove the emojis if you'd like, I just think they look cute :P
    ],
portfolio: [
    {
        title: "ERNIE",
        live: "https://github.com/aimlfsd/ERNIE",
        source: "https://github.com/aimlfsd/ERNIE",
        image: mock1,
        description: "ERNIE 4.5 and ERNIEKit – industrial-grade development toolkit based on PaddlePaddle."
    },
    {
        title: "gemini-cli",
        live: "https://github.com/aimlfsd/gemini-cli",
        source: "https://github.com/aimlfsd/gemini-cli",
        image: mock2,
        description: "Open-source AI agent that brings the power of Gemini directly into your terminal."
    },
    {
        title: "PeerLearnAI",
        live: "https://github.com/aimlfsd/PeerLearnAI",
        source: "https://github.com/aimlfsd/PeerLearnAI",
        image: mock3,
        description: "Peer-to-peer learning and mentorship platform powered by FastAPI and AI matching."
    },
    {
        title: "Dog-breeds",
        live: "https://github.com/aimlfsd/Dog-breeds",
        source: "https://github.com/aimlfsd/Dog-breeds",
        image: mock4,
        description: "Machine learning project to identify different breeds of dogs."
    },
    {
        title: "Data_Science_Library",
        live: "https://github.com/aimlfsd/Data_Science_Library",
        source: "https://github.com/aimlfsd/Data_Science_Library",
        image: mock5,
        description: "Colab notebook with common data science library imports."
    }
]
}